module.exports = __webpack_public_path__ + "img/account_balance@2x.5a32bb8a.png";